import React, { PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SystemActions } from '../redux-store/thunks/systems.thunks';

import { useLoadInternalSystems } from 'src/hooks/useLoadInternalSystems.hook';

import { EntitiesTabs } from './EntitiesTabs.container';
import PageHeader, { PageHeaderGroup, PageHeaderTitle } from '../components/page-header';
import { EntitiesRefreshButton } from '../components/entities-refresh-button/EntitiesRefreshButton.view';
import SesamLink from 'Common/Links/SesamLink';
import Button from 'Common/Button/Button';
import Page from '../components/page';

import type { RootState } from '../types/state.types';
import type { ShouldRenderRefreshButton } from '../types/common.types';

export const SystemsListPage: React.FC<
  PropsWithChildren<{
    shouldRenderRefreshButton: ShouldRenderRefreshButton;
    includeInternal: boolean;
  }>
> = ({ children, shouldRenderRefreshButton, includeInternal }) => {
  const dispatch = useDispatch();

  const subId = useSelector((state: RootState) => state.subscription.id);
  const subUrl = useSelector((state: RootState) => state.subscription.url);
  const token = useSelector((state: RootState) => state.subscription.token);

  const { loadInternalSystems } = useLoadInternalSystems(subUrl, token);

  const loadAll = (includeInternal?: boolean) => {
    if (includeInternal) {
      loadInternalSystems();
    } else {
      dispatch(SystemActions.loadAll());
    }
  };

  return (
    <Page>
      <PageHeader>
        <PageHeaderTitle>Systems</PageHeaderTitle>
        <PageHeaderGroup>
          <EntitiesRefreshButton
            onClick={() => loadAll(includeInternal)}
            shouldRenderRefreshButton={shouldRenderRefreshButton}
          />
          <SesamLink to={`/subscription/${subId}/systems/new`} buttonLink={true}>
            <Button theme="primary">New system</Button>
          </SesamLink>
        </PageHeaderGroup>
      </PageHeader>
      <EntitiesTabs subId={subId} entityType="systems">
        {children}
      </EntitiesTabs>
    </Page>
  );
};
